<template>
    <span>
        <img
            v-b-popover.hover.top="{
                content: name,
                disabled: !showPopoverName || !name,
            }"
            :src="src"
            :alt="name"
            :class="['tw-rounded-full', size, imgClasses]"
            loading="lazy"
        />
    </span>
</template>

<script>
import escapeHTML from "escape-html";

import generateDefaultProfilePicture from "@/utils/generate-default-profile-picture";
import generateFallbackPictureText from "@/utils/generate-fallback-picture-text";

const DEFAULT_PICTURE = "/img/icons/user_small.png";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            required: true,
            validator: value => ["xs", "s", "xm", "m", "l", "xl"].includes(value),
        },
        imgClasses: {
            type: String,
            default: "",
        },
        showPopoverName: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        src() {
            if (this.user?.picture && this.user?.picture !== DEFAULT_PICTURE) {
                return this.user.picture;
            }

            // Generate default picture with fallback text
            const fallbackText = this.user?.fallbackText
                ? escapeHTML(this.user?.fallbackText)
                : generateFallbackPictureText(this.user);

            return generateDefaultProfilePicture(fallbackText);
        },
        name() {
            return (
                this.user?.name ||
                this.user?.fullname ||
                `${this.user?.firstname} ${this.user?.lastname}`
            );
        },
    },
};
</script>

<style scoped>
.xs {
    width: 25px;
}
.s {
    width: 32px;
}
.xm {
    width: 38px;
}
.m {
    width: 60px;
}
.l {
    width: 80px;
}
.xl {
    width: 144px;
}
</style>
